import React from "react";
import styled from "styled-components";
import { withContentRect } from 'react-measure';

const HostedVideo = ({ videoSrcURL, videoTitle, width, height,...props }) => (
        <div className="video">
        <iframe
    src={videoSrcURL}
    title={videoTitle}
    width={width}
    height={height}
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    frameBorder="0"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    allowFullScreen
        />
        </div>
);

const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AdaptiveHostedVideo = withContentRect('client')(({ url, title, measureRef, contentRect, widthProportion }) => {
    const videoWidth = contentRect.client.width * (widthProportion || 0.9);
    const videoHeight= videoWidth * (9 / 16);

    return (
            <VideoContainer ref={measureRef}>
            {contentRect.client.width ?
             <HostedVideo
             videoSrcURL={url}
             title={title}
             width={videoWidth}
             height={videoHeight}
             /> :
             <></>}
        </VideoContainer>
    );
});

export { HostedVideo, AdaptiveHostedVideo };
